// extracted by mini-css-extract-plugin
export var section = "styles-module--section--kNtZ7";
export var lines = "styles-module--lines--wmXdt";
export var circle = "styles-module--circle--5njCo";
export var circle2020 = "styles-module--circle2020--TMM5K";
export var circle2019 = "styles-module--circle2019--4MNiZ";
export var circlePink = "styles-module--circlePink--ZXkvH";